import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_3"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 71.6 88.9"
    style={{
      enableBackground: "new 0 0 71.6 88.9",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.srb_st0{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.srb_st1{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0008;}\n\t.srb_st2{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0006;}\n\t.srb_st3{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:3.9996;}\n`
      }
    </style>
    <path className="srb_st0" d="M21.8,86.7c0,0,25.7-24.3,30.9-29.5" />
    <path className="srb_st0" d="M55.2,22l0.2,3.8c0,0.5,0.7,0.8,1.2,0.8l4.4-0.5c1.6-0.2,2.7-1.2,2.6-2.4l0,0c0-1.2-1.2-2.1-2.9-2.3l-4.4-0.2 C55.8,21.3,55.2,21.7,55.2,22L55.2,22z" />
    <path className="srb_st0" d="M34.1,3.3c4.3,1,20.8,21.1,20.7,20.5C56.1,22,43.9,8,35.4,1.8" />
    <path className="srb_st0" d="M52.8,21.8l2.4,4.7c0,0,3.3,22-1.7,30.4" />
    <path className="srb_st0" d="M11.5,6c0,0,9.8,30.1,12.3,33.1c2.4,7.3,2.4,4,3.1,17.3c0,0.7,0.5,11.9-0.4,25.8" />
    <path className="srb_st0" d="M55.2,56.8l0.1-0.4c0,0-1.3,0-2.6,0.9" />
    <path className="srb_st0" d="M58.5,67.5L51,66.1c-1.4-0.3-2.3-1.3-2.4-2.5l-0.1-1.9" />
    <path className="srb_st0" d="M67.9,48.4c0,0,1.7-14.5-3.1-12.6c0,0-5.4,2.4-9.2,18.9c-0.9,3.7-0.8,6.8-0.1,8.9" />
    <path className="srb_st0" d="M62.4,65c2.7-3.7,4-9.9,4-9.9l1.4-1.2c-0.2-0.8,0.2-6.4,0.6-8.5c0-0.3,0.2-0.8,0.2-1.1 c-0.4-8.9,0.1-12.2-1.1-13.6c-0.2-0.3-1.6-2.8-2.7-3.9c-0.3-0.7-1.2-1.1-2-1.4c-1,0.5-5,1.4-5.1,1c0,0-1.4-0.1-2.2-0.7" />
    <ellipse transform="matrix(0.1748 -0.9846 0.9846 0.1748 -0.6014 103.8857)" className="srb_st1" cx="61.7" cy="52.3" rx="11.9" ry="4.2" />
    <path className="srb_st0" d="M64.8,36.1c0,0,4.2,8.3,1.5,19.4" />
    <ellipse transform="matrix(0.1557 -0.9878 0.9878 0.1557 -0.4944 106.0256)" className="srb_st2" cx="61.8" cy="53.3" rx="2.6" ry="1.1" />
    <path className="srb_st0" d="M55.4,63.1c0.2,1.4,2.5,8.3,7.3,1.5" />
    <polygon className="srb_st3" points="38.2,37.8 44,35.6 44.7,37.1 38.9,39.2 " />
    <line className="srb_st0" x1="39.7" y1="37.2" x2="40.4" y2="38.7" />
    <ellipse className="srb_st0" cx="39.3" cy="38.2" rx="0.5" ry="0.4" />
    <line className="srb_st0" x1="55.1" y1="26.5" x2="2.4" y2="40.6" />
  </svg>
);
export default SvgComponent;
